/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

setTimeout(function () {
  const storeMapper = document.getElementById("storemapper-go");

  if (!storeMapper) {
    return;
  }

  storeMapper.addEventListener("click", addEventGA);
  //document.getElementsByClassName("storemapper-storelink").addEventListener("click", addEventGAShowMap);

  /*var elements = document.getElementsByClassName("storemapper-storelink");



for (var i = 0; i < elements.length; i++) {
    elements[i].addEventListener('click', addEventGAShowMap, false);
}*/
}, 6000);

function addEventGA() {
  ga("send", "event", "Store Locator", "Zoeken", "");
}
/*function addEventGAShowMap() {
        ga('send', 'event', 'Store Locator', 'View On Map', '');
}*/
